export const config = {
  apiUrl: window.location.origin
  // apiUrl: 'http://localhost:3000'
}
